






























































import { Component } from "vue-property-decorator";
import Manter from "./Manter.vue";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import Confirm from "@/shared/components/confirm.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import { dateTime } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import ComboStatus from "./ComboStatus.vue";
import {
  PromocaoService,
  Promocao,
  StatusPromocao,
} from "@/services/promocao.service";

@Component({
  components: { DataTable, Tooltip, DatePicker, Confirm, ComboStatus, Manter },
  filters: { dateTime },
})
export default class Promocoes extends mixins(GlobalMixin) {
  promise: Promise<Promocao[]> | null = null;
  tipo: number | null = null;
  itemsRes: string[] = [];

  headers = [
    { value: "nome", text: "Promoção" },
    { value: "dataInicial", text: "Data Inicial" },
    { value: "dataFinal", text: "Data Final" },
    { value: "status", text: "Status" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  mounted() {
    this.fetchPromocoes();
  }

  async fetchPromocoes() {
    switch (this.status(this.tipo)) {
      case "Ativa":
        this.promise = PromocaoService.Lista(StatusPromocao["Ativa"]);
        break;
      case "Programada":
        this.promise = PromocaoService.Lista(StatusPromocao["Programada"]);
        break;
      case "Inativa":
        this.promise = PromocaoService.Lista(StatusPromocao["Inativa"]);
        break;
      case "Finalizada":
        this.promise = PromocaoService.Lista(StatusPromocao["Finalizada"]);
        break;
      default:
        this.promise = PromocaoService.Lista(StatusPromocao.Null);
        break;
    }
  }

  status(status: number | null) {
    switch (status) {
      case 0:
        return "Inativa";
      case 1:
        return "Programada";
      case 2:
        return "Ativa";
      case 3:
        return "Finalizada";
      default:
        return "";
    }
  }

  async novoItem() {
    const modal = this.$refs.modalPromocao as Manter;
    await modal.novaPromocao();
    this.fetchPromocoes();
  }

  async excluirItem(item: Promocao) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir Promoção`;
    const text = `Deseja realmente excluir a promoção?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      if (item.idPromocao){
        await PromocaoService.ExcluirPromocao(item.idPromocao).finally(
          this.stopLoader
        );
        this.fetchPromocoes();
      }
    }
  }

  async copiarPromocao(promocao: Promocao) {
    const modal = this.$refs.modalPromocao as Manter;
    if (promocao) {
      await modal.copiarPromocao(promocao);
    }
    this.fetchPromocoes();
  }

  selecionadoPromocao(item: any) {
    this.$router.push({
      name: "alterarpromocao",
      params: { idPromocao: item.idPromocao },
    });
  }
}
